var map = {
	"./icon--c-programación.svg": 9758,
	"./icon-award-fill.svg": 5956,
	"./icon-bi-translate.svg": 9089,
	"./icon-bootstrap.svg": 8128,
	"./icon-briefcase-fill.svg": 3377,
	"./icon-c-plus-plus.svg": 7809,
	"./icon-c-sharp.svg": 8343,
	"./icon-date.svg": 1060,
	"./icon-envelope-at-fill.svg": 6663,
	"./icon-file-image.svg": 2691,
	"./icon-git.svg": 5391,
	"./icon-github.svg": 1614,
	"./icon-google.svg": 2915,
	"./icon-html_5.svg": 1721,
	"./icon-javascript.svg": 4404,
	"./icon-jira.svg": 6261,
	"./icon-jquery.svg": 4697,
	"./icon-link.svg": 6023,
	"./icon-linkedin.svg": 3565,
	"./icon-mortarboard-fill.svg": 698,
	"./icon-mysql.svg": 157,
	"./icon-node-js.svg": 8660,
	"./icon-phone.svg": 7186,
	"./icon-place.svg": 7972,
	"./icon-plus-circle.svg": 7983,
	"./icon-postgresql.svg": 1471,
	"./icon-print.svg": 3803,
	"./icon-qt.svg": 9439,
	"./icon-react.svg": 9763,
	"./icon-sass.svg": 8734,
	"./logo.svg": 5522,
	"./spinning-cogs.svg": 619
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7064;